"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-vars */
var react_1 = __importDefault(require("react"));
var defaultContext = {
    defaults: {},
    experiments: {},
    serverCookies: {},
    updateExperiment: function (name, updatedExperiments) { }
};
var ExperimentProviderContext = react_1.default.createContext(defaultContext);
exports.default = ExperimentProviderContext;
